<section class="news-container space">
    <div class="container">
        <div class="flex">
            <div class="row">
                <div class="col-xs-12 col-sm-6">
                    <a routerLink="./aboutme/work/frontend" class="news-item-container">
                        <div class="row">
                            <div class="col-xs-12 col-md-6">
                                <picture>
                                    <source media="(min-width: 1200px)"
                                            srcset="/assets/img/home/slider/lg/frontend.png">
                                    <source media="(min-width: 992px)"
                                            srcset="/assets/img/home/slider/md/frontend.png">
                                    <source media="(min-width: 480px)"
                                            srcset="/assets/img/home/slider/sm/frontend.png">
                                    <source media="(min-width: 0px)" srcset="/assets/img/home/slider/xs/frontend.png">
                                    <img class="img-responsive" src="assets/img/home/slider/lg/frontend.png"
                                         alt="Alexander Koenig">
                                </picture>
                            </div>
                            <div class="col-xs-12 col-md-6">
                                <div class="news-content-container">
                                    <h3 class="headline">Frontend Entwicklung</h3>
                                    <div class="news-content">
                                        <p>Als Frontend Entwickler bin ich immer daran interessiert, meine kreativen Ideen zusammen
                                            mit Designern zu erarbeiten und umzusetzen.</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </a>
                </div>
                <div class="col-xs-12 col-sm-6">
                    <a routerLink="./photography" class="news-item-container">
                        <div class="row">
                            <div class="col-xs-12 col-md-6">
                                <picture>
                                    <source media="(min-width: 1200px)"
                                            srcset="/assets/img/home/slider/lg/fotografie.png">
                                    <source media="(min-width: 992px)"
                                            srcset="/assets/img/home/slider/md/fotografie.png">
                                    <source media="(min-width: 480px)"
                                            srcset="/assets/img/home/slider/sm/fotografie.png">
                                    <source media="(min-width: 0px)" srcset="/assets/img/home/slider/xs/fotografie.png">
                                    <img class="img-responsive" src="assets/img/home/slider/lg/fotografie.png"
                                         alt="Alexander Koenig">
                                </picture>
                            </div>
                            <div class="col-xs-12 col-md-6">
                                <div class="news-content-container">
                                    <h3 class="headline">Fotografie</h3>
                                    <div class="news-content">
                                        <p>Meine Leidenschaft ist Fotografie. Nichts ist schöner, als seine Gedanken und
                                            Vorstellungen in Bildern festzuhalten.</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </a>
                </div>

            </div>
        </div>
    </div>
</section>
